import { StepObject } from '../../types';

export const noSteps = (steps: StepObject[]) => steps.length === 0;
